import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    DialogContent,
    DialogContentText,
    DialogActions,
    DefaultButton,
} from '@bb-ui/react-library';
import { Warning } from '@bb-ui/icons/dist/medium';

export const ApiFailureDialogContent = (props: {
    closeDialog: () => void;
    errorText: string;
    closeTestId: string;
    // Lets a parent that animates this content focus Close once it is visible.
    closeButtonRef?: React.RefObject<HTMLButtonElement>;
}) => {
    const { t } = useTranslation();
    const { closeDialog, errorText, closeTestId } = props;
    const ownCloseButtonRef = React.useRef<HTMLButtonElement>(null);
    const closeButtonRef = props.closeButtonRef ?? ownCloseButtonRef;

    // The dialog form unmounts when this content mounts, so focus is lost. Move
    // it to the Close button so keyboard/AT users don't lose their place.
    // If a parent fades this content in, focus() is ignored while it is still
    // hidden, so that parent focuses Close again when the fade has finished.
    React.useEffect(() => {
        closeButtonRef.current?.focus();
    }, [closeButtonRef]);

    return (
        <>
            <DialogContent
                style={{
                    minHeight: '160px',
                    // top and bottom "margin" the same
                    justifyContent: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Warning
                    color="error"
                    style={{ alignSelf: 'center', fontSize: '35px' }}
                />

                <DialogContentText
                    role="alert"
                    style={{ margin: '10px 0 0 0', textAlign: 'center' }}
                >
                    {errorText}
                </DialogContentText>

                <DialogContentText style={{ textAlign: 'center', margin: '0' }}>
                    {t('settings.licenseManagement.tryAgainOrContactSupport')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <DefaultButton
                    buttonRef={closeButtonRef}
                    data-testid={closeTestId}
                    onClick={closeDialog}
                >
                    {t('general.close')}
                </DefaultButton>
            </DialogActions>
        </>
    );
};
